export default "__VITE_ASSET__0Gn_52SH__"